import { Permissions } from '@logz-pkg/enums';
import { ConditionType, IExpandedNavItemConfig } from './item-configs';

export const notificationEndpointsNavigationItem: IExpandedNavItemConfig = {
  icon: 'envelope-solid',
  text: 'Notification endpoints',
  targetStateName: 'dashboard.alerts.endpoints',
  displayConditions: [{ type: ConditionType.Permission, value: Permissions.ENDPOINT_PERMISSION }],
};
